import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { useAuthStore } from '@modules/auth/store/auth-store';

export type CreateUsernameInput = { username: string };
export type CreateUsernameResponse = { username: string };

const useCreateUsername = () => {
  const { setScreenName } = useAuthStore();

  return useMutation<
    AxiosResponse<CreateUsernameResponse>,
    AxiosError<{ [key: string]: string[] }>,
    CreateUsernameInput
  >({
    mutationFn: async ({ username }) => {
      setScreenName(username);

      return {
        data: { username },
        status: 200,
        statusText: 'OK',
        headers: {},
        config: {} as InternalAxiosRequestConfig<unknown>,
      };
    },
  });
};

export { useCreateUsername };
